import axios from "axios";
import config from "./config";


export function buildUrl(data) {
    let i = 0
    let url = config.url;
    let allParams = {
        ...config.params,
        ...data,
    }
    for (var key in allParams) {
        let query = "&";
        if (i === 0) {
            query = "?";
        }
        url += query + key + "=" + allParams[key];
        i++;
    }
    return axios.get(url);
}


export function redirectPayFip(token) {
    return window.location = `https://www.payfip.gouv.fr/tpa/paiementws.web?idop=${token}`;
}